<template>
	<div class="l-row--t128 l-row--t256l module c-sep">
		<div class="g-row">
			<div class="g-col--9 g-col--4s c-sep__item i--title">
				<div class="t-h--28 t-h--18s" v-html="data.target.title">
				</div>
			</div>
			<div class="g-col--9 g-col--4s c-sep__item i--body">
				<div class="t-b--18 t-b--16s i--body-en" v-html="data.target.body"></div>
				<div class="l-mdl--16 t-b--18 t-b--16s i--body-kr" v-html="data.target.bodyKo"></div>
			</div>
		</div>
	</div>	
</template>

<script>
import * as _ from "fxjs";
import { computed, ref, reactive, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";

export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture
	},
  setup(props) {
    const { get } = useStore();
		const self = ref();
		const data = reactive({
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

    return {
			self,
			data,
    };
  },
};
</script>

<style scoped lang="scss"></style>